import { ITravellerInfo } from '../journey/journey';
import { IHub } from '../hub/hub';
import { IFleet } from '../transferCompany/transferCompany'

export interface IQuote {
  id: number;
  partnerId: number;
  requestId: number;
  vehicleCategory: string;
  passengerCapacity: number;
  luggageCapacity: number;
  fareCalculationType: FareCalculationType;
  priceCalculationSettingType: PriceCalculationSettingType;
  hubId: number;
  hub: IHub;
  expires: number
  pricingInput: IPricingInput;
  price: IPrice;
  travelAddons: ITravelAddon[];
  currencyCode: string;
  combinedBabyAndBoosterSeatsCapacity: number;
  ids: number[];
  calculateEmissions?: boolean;
  emissions?: IEmissions;
  fleet?: IFleet;
  preselectedFleetId?: number;
  pricePerPassenger: number;
  vehicleModels: string;
  includedWaitingTimeInMinutes: number;
  fareCalculationGeoZoneId: number;
  partnerPriceCalculationGeoZoneId: number;
  destinationLocationId: number;
  originLocationId: number;
}

export enum FareCalculationType {
  GEO_ZONE = 'GEO_ZONE',
  ZIP_CODE = 'ZIP_CODE',
  RADIUS = 'RADIUS',
  DISTANCE = 'DISTANCE',
}

export enum PriceCalculationSettingType {
  GLOBAL = 'GLOBAL',
  HUB = 'HUB',
  GEO_ZONE = 'GEO_ZONE',
  FIXED = 'FIXED',
}

export interface IEmissions {
  carbonDioxideInMetricTonnes: number;
}

export interface ITravelAddon {
  id: number;
  type: string;
  fare: number;
  price: IPrice;
  maxAllowed: number;
  quoteTravelAddonIdPairs?: {
    [key: string]: string;
  };
}

export interface IPricingInput {
  fare: number;
  fareVatLevel: number;
  fareCurrencyCode: string;
  partnerBusinessModel: string;
  partnerCommission: number;
  platformFee: number;
  platformMarkup: number;
  platformMarkupCurrencyCode: string;
}

export interface IPrice {
  price: number;
  vat: number;
  fareVat: number;
  partnerMargin: number;
  partnerMarginVat: number;
  platformMargin: number;
  platformMarginVat: number;
  discount: number;
  discountVat: number;
}

export interface IGeneratedQuoteRequestParams {
  partnerId: number;
  hub: number;
  directionality: string;
  destination: string;
  passengers?: number;
  adultPassengerCount?: number;
  infantPassengerCount?: number;
  childPassengerCount?: number;
  luggage: number;
  inboundPickup: string;
  outboundPickup: string
  isRoundTrip: boolean
  preferredCurrencyCode?: string;
}

export interface IGeneratedQuote {
  ids: number[];
  hubId: number;
  requestId: number;
  vehicleCategory: string;
  passengerCapacity: number;
  luggageCapacity: number;
  price: number;
  travelAddons: ITravelAddon[];
  currencyCode: string;
  combinedBabyAndBoosterSeatsCapacity: number;
  pricePerPassenger: number;
  vehicleModels: string;
  includedWaitingTimeInMinutes: number;
  discount: number;
}

export interface IBookingQuote {
  quoteId: number;
  quoteTravelAddons: IBookingQuoteTravelAddon[];
  travellerInfo?: ITravellerInfo;
}

export interface IBookingQuoteTravelAddon {
  quoteTravelAddonId: number;
  amount: number;
}

export interface IQuoteRequestParams {
  originLocationId: number;
  destinationLocationId: number;
  pickupTime: String
  passengerCount: number;
  luggageCount: number
  partnerId: number
  preferredCurrencyCode: String;
  ignoreBookingWindow?: Boolean;
  calculateEmissions?: Boolean;
}
